export default __webpack_public_path__ + "media/images/brighteon-social/Icon-Filters-Gray-bf93075a769a952878101fd2923fb291.svg";